import { useMemo } from 'react';

const useDataSecondaryBrand = () => {
	const secondaryBrandAttribute = useMemo(() => {
		const attribute = 'data-secondary-brand';
		return document
			.querySelector(`main[${attribute}]`)
			?.getAttribute(attribute)
			?.toLowerCase();
	}, []);

	return secondaryBrandAttribute;
};

export default useDataSecondaryBrand;
